export const YnType = {
  Y: 'Y',
  N: 'N'
} as const;

export type YnType = (typeof YnType)[keyof typeof YnType];

export const YnTypeList = Object.values(YnType);

export const YnTypeKeys = Object.keys(YnType);

export const FindYnTypeKeys = (value: YnType) => {
  return YnTypeKeys.find(
    (key): key is keyof typeof YnType => YnType[key as keyof typeof YnType] === value
  );
};
